import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {HStack, VStack} from "native-base";
import {toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import {isMobile} from "../../../../../../../services/Helpers";
import CustomSwitch from "../../../../../../common/CustomSwitch";
import AppText from "../../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {t} from "../../../../../../../services/i18n";
import {MISSING_USER_NOTE_INDICATOR} from "../../../../../../../services/ConstHelper";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";

const MissingUserNote = (props) => {
    const { values, setFieldValue } = props;
    const dispatch = useDispatch()

    const toggle = async (val) => {
        try {
            setFieldValue('showMissingUserNote', val)
            if (isMobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = {prop_name: MISSING_USER_NOTE_INDICATOR, properties: {active: !!val}}
                const res = await fetchApi(`boxes/settings`, 'POST', setting, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true))
                dispatch(updateBox({
                    settings: {
                        ...store.getState().box.box.settings,
                        [MISSING_USER_NOTE_INDICATOR]: setting.properties
                    }
                }))
            }
        } catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }

    return (
        <>
            {isMobile ? <CustomSwitch isChecked={values?.showMissingUserNote} onToggle={toggle} style={{ width: isMobile && 'inherit' }} />
                :
                <VStack space={'0.25rem'}>
                    <HStack justifyContent={'space-between'} alignItems={'center'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('missingUserNoteLbl')}</AppText>
                        <CustomSwitch isChecked={values?.showMissingUserNote} onToggle={toggle} style={{ width: isMobile && 'inherit' }} />
                    </HStack>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('missingUserNoteTxt')}</AppText>
                </VStack>}
        </>
    );
};

export default MissingUserNote;